import React from "react";

const PageNotFound = () => {
  return (

    <div
      style={{
        margin: "auto",
        width: "50%",

        padding: "10px",
      }}
    >
      <h1>404 Error</h1>
      <h1>Page Not Found</h1>
    </div>

  );
};

export default PageNotFound;
